<script setup>
import useGrid from "@/composables/useGrid";
import {onMounted, ref, watch} from "vue";
import aiChatLogsService from "@/services/ai-chat-logs.service";
import CommonGrid from "../../../../../frontend/src/components/CommonGrid.vue";
import AiChatModal from "@/views/tools/aiChat/AiChatModal.vue";

const {items, gridParams, gridMethods} = useGrid(getList);
const chatModal = ref(null);

const columns = [
    {
        label: 'Question',
        name: 'question',
    },
    {
        label: 'User',
        name: 'email',
        filter: 'text',
    },
    {
        label: 'Created At',
        name: 'created_at',
    },
    {
        name: 'actions',
        label: 'Actions',
        component: 'Actions',
    },
];

const withErrors = ref(false);

watch(withErrors, () => {
    gridMethods.resetList();
});

onMounted(() => {
    gridMethods.setColumns(columns);
    gridMethods.resetList();
});

function getList(pageParams) {
    if (withErrors.value) {
        pageParams.filters.with_errors = true;
    } else {
        delete pageParams.filters.with_errors;
    }

    return aiChatLogsService.getConversationsList(pageParams);
}

function gridAction(params) {
    if (params.action === 'view') {
        chatModal.value.open(params.rowId);
    }
}

</script>

<template>
    <div>
        <div class="topbar">
            <div class="topbar__inner">
                <div class="topbar__key">
                    <header class="buttons-container">
                        <div class="input-checkbox pt-1">
                            <input id="withErrors" class="ml-2" type="checkbox" v-model="withErrors">
                            <label for="withErrors">With errors</label>
                        </div>
                    </header>
                </div>
            </div>
        </div>

        <div class="main-table-wrapper">
            <div class="main-table overflow-auto">
                <CommonGrid
                    :columns="columns"
                    :items="items"
                    :gridParams="gridParams"
                    :gridMethods="gridMethods"
                    :gridAction="gridAction"
                />
            </div>
        </div>

        <AiChatModal ref="chatModal"/>
    </div>
</template>

<style scoped>

</style>
